module.exports = __webpack_public_path__ + "img/create_restaurant_filled.9cbef616.svg";